<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    computed: {
      ...mapGetters({
        pageCacheList: 'pageCache/getPageCacheList',
      }),
      pageCache() {
        return this.pageCacheList.join(',')
      },
    },
  }
</script>

<style lang="less">
  body {
    margin: 0;
    bottom: 0;
  }
</style>
